// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"92c37672","667":"e1580ca7"}[chunkId] + ".chunk.js";
};